import { AbortControllerManager } from '../abortControllerManager';
import { authClient, infermedicaClient } from '../client';
import { IMedicalSpecialtyResponse } from '@/types';
import {
  TInfemedicaAnswer,
  IInfemedicaKnowledgeResponse,
  TInfemedicaQuestion,
  TSurveyResults,
  TInfermedicaSymptomsResponse,
} from '@/types/infermedica';

class InfermedicaApi extends AbortControllerManager {
  constructor() {
    super();
  }

  getAccessTokenAndSurvey() {
    const url = '/v2/infermedica/token';
    const signal = this.createAbortController('getAccessTokenAndSurvey');
    return authClient.get<{
      data: {
        access_token: string;
        survey_id: string;
        refresh_token: string;
      };
    }>(url, { signal });
  }

  getIndexedQuestion(surveyId: string, questionIndex: number) {
    const url = `/surveys/${surveyId}/questions/${questionIndex}`;
    const signal = this.createAbortController(
      `getIndexedQuestion-${surveyId}-${questionIndex}`,
    );
    return infermedicaClient.get<TInfemedicaQuestion>(url, { signal });
  }

  giveIndexedAnswer(
    surveyId: string,
    questionIndex: number,
    answer: TInfemedicaAnswer,
  ) {
    const url = `/surveys/${surveyId}/questions/${questionIndex}`;
    const signal = this.createAbortController(
      `giveIndexedAnswer-${surveyId}-${questionIndex}`,
    );
    return infermedicaClient.put<TInfemedicaQuestion>(
      url,
      { answer },
      { signal },
    );
  }

  getResults(surveyId: string) {
    const url = `/surveys/${surveyId}/specialist_recommendation`;
    const signal = this.createAbortController(`getResults-${surveyId}`);
    return infermedicaClient.get<TSurveyResults>(url, { signal });
  }

  getKnowledgeEndpoint({ url, query }: { url: string; query: string }) {
    const signal = this.createAbortController(`getKnowledgeEndpoint-${query}`);
    return infermedicaClient.get<IInfemedicaKnowledgeResponse>(
      url.replace(/^\/v\d+\//, '/'),
      {
        params: { query },
        signal,
      },
    );
  }

  getSpecialties() {
    const url = 'v2/infermedica/specialties';
    const signal = this.createAbortController('getSpecialties');
    return authClient.get<IMedicalSpecialtyResponse>(url, { signal });
  }

  getSymptoms() {
    const url = '/v2/infermedica/symptoms';
    const signal = this.createAbortController('getSymptoms');
    return authClient.get<TInfermedicaSymptomsResponse>(url, { signal });
  }
}

export const infermedicaApi = new InfermedicaApi();
